var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetirementPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8107 43.5812H44.8242M26.388 43.5812C25.4976 40.3229 23.9991 34.6453 23.0526 31.1308M23.0526 31.1308C20.0371 19.9345 16.9529 8.34667 15.1801 2.15832C15.1547 2.06948 15.0601 2.02237 14.9719 2.05018C8.3361 4.14378 7.43376 10.4026 8.19123 13.1735C10.2929 20.8619 14.8123 38.1445 17.3694 45.8159C19.205 51.3228 22.7167 52.8392 26.7072 52.8392C31.8417 52.8392 44.6326 52.8392 54.7206 52.8392C60.0679 52.8392 60.2275 43.5812 54.7206 43.5812H44.8242M23.0526 31.1308H44.8242M59.19 36.2386C59.19 32.9664 56.3966 31.1308 54.162 31.1308H44.8242M44.8242 31.1308V43.5812",
    stroke: "#F4F4F9",
    strokeWidth: 2.98511
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8951 64.2279C12.719 62.9267 10.6103 61.4432 8.59015 59.7828C4.9188 56.9312 -0.278864 62.6905 3.64191 66.008C26.4675 85.322 54.0021 80.9324 71.8797 66.9658C76.748 63.1624 71.0336 56.3535 67.2507 59.7828C65.4036 61.4573 63.4744 62.9375 61.4803 64.2279M14.8951 64.2279L23.355 52.52M14.8951 64.2279C29.5102 72.9675 47.1667 73.4902 61.4803 64.2279M61.4803 64.2279L53.204 53.2383",
    stroke: "#F4F4F9",
    strokeWidth: 2.98511
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementPlanning);
export default __webpack_public_path__ + "static/media/Retirement-Planning.bb64494e3ab798833af340d6e975e261.svg";
export { ForwardRef as ReactComponent };